
























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Accordion extends Vue {
  @Prop({ default: false }) hideIcon?: boolean;
  @Prop({ default: false }) showShadow?: boolean;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: null }) open?: 0 | null;
  @Prop({ default: true }) border: boolean;
  @Prop({ default: false }) light?: boolean;
  @Prop({ default: false }) noMargin?: boolean;
}
